export default __webpack_public_path__ + "static/bonvin-logo-413ce6792d7cd2599b591d0ca062606b.jpg";